import type { Place } from '@raahi/shared';

export interface CityPlaces {
  city: string;
  centre: { lat: number; lng: number };
  places: Place[];
}

export const CITY_DIRECTORY: CityPlaces[] = [
  {
    city: 'Karachi',
    centre: { lat: 24.8607, lng: 67.0011 },
    places: [
      { label: 'Saddar', lat: 24.8607, lng: 67.0011 },
      { label: 'Gulshan-e-Iqbal', lat: 24.9056, lng: 67.0822 },
      { label: 'Clifton', lat: 24.8138, lng: 67.0299 },
      { label: 'Defence Phase 5', lat: 24.7964, lng: 67.0596 },
      { label: 'Jinnah International Airport', lat: 24.9008, lng: 67.1681 },
      { label: 'Dolmen Mall Tariq Road', lat: 24.8779, lng: 67.0671 },
    ],
  },
  {
    city: 'Lahore',
    centre: { lat: 31.5204, lng: 74.3587 },
    places: [
      { label: 'Mall Road', lat: 31.5577, lng: 74.3251 },
      { label: 'Liberty Market, Gulberg', lat: 31.5181, lng: 74.3477 },
      { label: 'DHA Phase 6', lat: 31.475, lng: 74.42 },
      { label: 'Allama Iqbal Airport', lat: 31.5216, lng: 74.4036 },
      { label: 'Anarkali Bazaar', lat: 31.5722, lng: 74.3091 },
    ],
  },
  {
    city: 'Islamabad',
    centre: { lat: 33.6844, lng: 73.0479 },
    places: [
      { label: 'F-7 Markaz', lat: 33.7203, lng: 73.0454 },
      { label: 'Centaurus Mall', lat: 33.7077, lng: 73.0509 },
      { label: 'Faisal Mosque', lat: 33.7295, lng: 73.0372 },
      { label: 'Islamabad International Airport', lat: 33.5407, lng: 72.8252 },
      { label: 'Rawalpindi Saddar', lat: 33.6007, lng: 73.0679 },
    ],
  },
];
